/* eslint-disable jsx-a11y/anchor-is-valid */
const BASEURL = process.env.REACT_APP_DEV_APP_ONLINE
export function LoginOnline() {

  const handleLogin = () => {
    window.location.href = BASEURL
  }

  return (
    <div className='form w-100' id='kt_login_signin_form'>
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Iniciar Sesión</h1>
        <div className='text-muted fw-semibold fs-6'>
          Ingrese conectándose al modo ONLINE.
        </div>
      </div>

      <div className='d-grid mb-10'>
        <button
          id='kt_sign_in_submit'
          className='btn btn-primary'
          onClick={handleLogin}
        >
          <span className='indicator-label'>Ingresar al sistema</span>
        </button>
      </div>
    </div>
  )
}
